var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSortDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23 7.02669L9.28 1.62669C9.57666 1.23114 9.29443 0.666685 8.8 0.666685L0.7 0.666687C0.205573 0.666687 -0.0766564 1.23115 0.22 1.62669L4.27 7.02669C4.51 7.34669 4.99 7.34669 5.23 7.02669Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSortDown);
export default __webpack_public_path__ + "static/media/ico-sort-down.64ca8407ecb196fce7367f9d36557cc1.svg";
export { ForwardRef as ReactComponent };